import { Link } from "react-router-dom";
export default function InsightsPreview() {
  return (
    <section className="section-space">
      <div className="shell purpose-grid">
        <div>
          <p className="eyebrow">Ideas into action</p>
          <h2>
            A practical place
            <br />
            to begin.
          </h2>
        </div>
        <div>
          <p className="large-copy">
            Good collaboration starts with clear questions.
          </p>
          <p className="body-copy">
            Explore our conversation guides for learning, enterprise, and
            partnership. Our resource library will grow alongside our work.
          </p>
          <Link className="text-link" to="/insights">
            Explore Insights & Resources <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
